/*

  html:
   <a
    href="{{ variant_url }}"
    class="color-swatch {{ color_array.first | replace: ' ', '-' | downcase }}"
    data-color-swatch="{{ value | handle }}"
    data-product-id="{{ product.id }}"
    role="button"
    tabindex="0"
    aria-label="Select {{ value }} color variant"
  ></a>

*/

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const swatches = document.querySelectorAll(".color-swatch");
    const originalColors = new Map();

    swatches.forEach((swatch) => {
      const productId = swatch.getAttribute("data-product-id");
      const productCard = swatch.closest(".product-card");
      if (productCard) {
        const colorNameContainer = productCard.querySelector(
          `#color-text-${productId}`
        );
        if (colorNameContainer) {
          originalColors.set(productId, colorNameContainer.textContent);
        }
      }

      swatch.addEventListener("mouseenter", function () {
        updateColorText(this, true);
      });

      swatch.addEventListener("mouseleave", function () {
        updateColorText(this, false);
      });
    });

    function updateColorText(swatch, isEnter) {
      const colorName = swatch.getAttribute("data-color-swatch");
      const productId = swatch.getAttribute("data-product-id");
      const productCard = swatch.closest(".product-card");

      if (productCard) {
        const colorNameContainer = productCard.querySelector(
          `#color-text-${productId}`
        );

        if (colorNameContainer) {
          colorNameContainer.textContent = isEnter
            ? colorName
            : originalColors.get(productId);
        } else {
          console.log(
            "Color name container not found for product " + productId
          );
        }
      } else {
        console.log("Product card not found for swatch");
      }
    }
  });
})();

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(
    ".accordion-button[data-accordion-button-id]"
  );

  buttons.forEach((button) => {
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);

    newButton.addEventListener("click", function (event) {
      event.preventDefault();

      const id = this.getAttribute("data-accordion-button-id");
      const content = document.querySelector(
        `.accordion-content[data-accordion-content-id="${id}"]`
      );
      const parent = content.parentElement;
      const isExpanded = content.classList.contains("active");

      if (isExpanded) {
        // Collapse
        content.style.height = content.scrollHeight + "px"; // Set current height
        requestAnimationFrame(() => {
          content.style.height = "0px";
          content.classList.remove("active");
          parent.classList.remove("active");
        });
      } else {
        // Expand
        content.classList.add("active");
        parent.classList.add("active");
        const targetHeight = content.scrollHeight + "px";
        content.style.height = "0px"; // start from 0
        requestAnimationFrame(() => {
          content.style.height = targetHeight;
        });
      }

      // Reset height after transition to allow auto resizing (optional)
      content.addEventListener(
        "transitionend",
        () => {
          if (content.classList.contains("active")) {
            content.style.height = "auto";
          } else {
            content.style.height = "0";
          }
        },
        { once: true }
      );
    });
  });
});

// MOBILE MENU
document.addEventListener("DOMContentLoaded", function () {
  function setupTabs() {
    const tabButtons = document.querySelectorAll(".tab-button[data-tab-button-id]");

    tabButtons.forEach((button) => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener("click", function (event) {
        const buttonId = this.getAttribute("data-tab-button-id");
        const isActive = this.classList.contains("active");

        if (!isActive) {
          // Tab wechseln und NICHT weiterleiten!
          event.preventDefault();
          event.stopPropagation();

          document.querySelectorAll(".tab-content").forEach((el) => {
            el.classList.remove("active");
          });
          document.querySelectorAll(".tab-button").forEach((btn) => {
            btn.classList.remove("active");
            btn.setAttribute("aria-expanded", "false");
          });

          const content = document.querySelector(
            `.tab-content[data-tab-content-id="${buttonId}"]`
          );
          if (content && !content.classList.contains("active")) {
            content.classList.add("active");
            this.classList.add("active");
            this.setAttribute("aria-expanded", "true");
          }
        }
        // Wenn isActive: Kein preventDefault, es wird zur URL navigiert!
      }, true);
    });
  }

  setupTabs();
});

// TO TOP BUTTON
document.addEventListener("DOMContentLoaded", function () {
  const toTopBtn = document.querySelector(".to-top-button");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 600) {
      toTopBtn.classList.add("visible");
    } else {
      toTopBtn.classList.remove("visible");
    }
  });
});

// ACCOUNT ADDRESSES
document.addEventListener("DOMContentLoaded", function () {
  const overview = document.getElementById("address-overview");
  const newForm = document.getElementById("new-address-form");

  // ❗️Script nur ausführen, wenn die Seite ein Adress-Overview oder ein New-Formular enthält
  if (!overview && !newForm) return;

  const showNewBtn = document.getElementById("showNewAddress");
  const showNewBtnTop = document.getElementById("showNewAddressTop");

  // 👉 Adresse hinzufügen anzeigen
  showNewBtn?.addEventListener("click", () => {
    overview?.classList.add("hidden");
    newForm?.classList.remove("hidden");
  });

  showNewBtnTop?.addEventListener("click", () => {
    overview?.classList.add("hidden");
    newForm?.classList.remove("hidden");
  });

  // 👉 Adresse hinzufügen abbrechen
  const cancelNew = newForm?.querySelector(".cancel-address-form");
  cancelNew?.addEventListener("click", () => {
    newForm?.classList.add("hidden");
    overview?.classList.remove("hidden");
  });

  // 👉 Adresse bearbeiten
  document.querySelectorAll(".edit-address-btn").forEach((button) => {
    button.addEventListener("click", () => {
      const addressId = button.dataset.addressId;
      const editForm = document.querySelector(
        `.edit-address-content[data-edit-address-id="${addressId}"]`
      );

      if (editForm) {
        overview?.classList.add("hidden");
        editForm.classList.remove("hidden");

        const cancelEdit = editForm.querySelector(".cancel-address-form");
        cancelEdit?.addEventListener("click", () => {
          editForm.classList.add("hidden");
          overview?.classList.remove("hidden");
        });
      }
    });
  });

  // 👉 Adresse löschen
  document.querySelectorAll(".delete-address-btn").forEach((button) => {
    button.addEventListener("click", () => {
      const id = button.dataset.addressId;
      if (
        confirm(
          window.translations?.delete_confirm ||
            "Möchtest du diese Adresse wirklich löschen?"
        )
      ) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = `/account/addresses/${id}`;
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "_method";
        input.value = "delete";
        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
      }
    });
  });
});

// CART SCRIPT - VERHINDERT DAS ÖFFNEN DES CARTDRAWERS AUF DER /CART SEITE
document.addEventListener("DOMContentLoaded", function () {
  const cartIcon = document.querySelector("#cart-icon-bubble");

  if (cartIcon) {
    cartIcon.addEventListener("click", function (e) {
      if (window.location.pathname === "/cart") {
        e.preventDefault();
        window.location.reload();
      }
    });
  }
});

// PRODUCT LINK DYNAMIC VARIANT
document.addEventListener("click", function (event) {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return; // Nur linker Mausklick ohne Modifier
  }

  const link = event.target.closest("a[data-variant-link]");
  if (!link) return;

  const href = link.getAttribute("href");
  if (!href) return;

  const hashMatch = href.match(/#variant=(\d+)/);
  if (!hashMatch) return;

  const variantId = hashMatch[1];
  const baseUrl = href.split("#")[0];

  // Verhindere Standardverhalten
  event.preventDefault();

  // Navigiere zur neuen URL mit ?variant=...
  const newUrl = `${baseUrl}?variant=${variantId}`;
  window.location.href = newUrl;
});
